(function HotelDetails($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/Hotels/hotelDetails/', function onload()
		{
			var max_time      = 600, // max amount of seconds before we say to retry
				current_timer = 0,
				interval,
				comparisonRateCode;

			HE.Web.POIMap();

			$('a#view-map').click(function showMap() {
				event.preventDefault();
				$('#hotel-info-tabs a[href="#map"]').tab('show');

				setTimeout(function scrollToMap() {
					$('html, body').animate({
						scrollTop: $('#poi-map-container').offset().top
					}, 1000);
				}, 500);
			});

			// so it scrolls on nav link activation
			$('a.nav-link').on('shown.bs.tab', function scrollToTab(e) {
				var $self = $(this);

				$('.nav-link').removeClass('active');
				$self.addClass('active');
			});

			$('input.rate-select').on('change', function swapRateInfo() {
				var $self   = $(this),
					$room   = $self.closest('.card'),
					$select = $room.find('a.select-room'),
					data    = $self.data(),
					savings = parseFloat(data['savings']); // need the raw float value without the %

				let $clipPrice = $room.find('.client-program-value');
				console.log(data, 'data');
				console.log($clipPrice, 'clip Price');
				console.log(data['programModel'], 'program Model');
				console.log(data['programValue'], 'program value');

				if (savings <= 0) {
					$('#you-save').hide();
				} else {
					$('#you-save').show();
				}

				$room.find('.per-night').html(data['sellingPrice']);
				$room.find('.taxes-fees').html(data['taxesFees']);
				$room.find('.savings-pct').html(data['savingsPct']);
				$room.find('.selling-price').html(data['nightly']);
				$room.find('.client-program-value').html(data['programValue']);
				$select.prop('href', HE.get_url($select.data('uri') + data['rateSelect']));
			});


			// TriggerModal if not logged in
			$('a.select-room').on('click', function selectRoom(e) {

				var selectedRate = null;
				var dataUri = null;
				var oneOptionOnly = null;
				var childrenStayFree = false;
				var roomId = $(this).closest('.card').data('room-id');
				var $selectedInput = $(`.card[data-room-id="${roomId}"] input.rate-select:checked`);


				var checkedSpan = $(`.card[data-room-id="${roomId}"] .text-success.checked, .card[data-room-id="${roomId}"] .text-danger.checked`);

				if (checkedSpan.length > 0) {
					oneOptionOnly = checkedSpan.data("input-id");
				}

				if ($selectedInput.length > 0) {
					selectedRate = $selectedInput.data('rate-select');
					childrenStayFree = Boolean($selectedInput.data('children-stay-free'));
				} else if (oneOptionOnly.length > 0) {
					selectedRate = oneOptionOnly;
					childrenStayFree = Boolean(checkedSpan.data('children-stay-free'));
				} else {
					console.log('No rate-select input is checked.');
				}

				dataUri ='/Hotels/selectRoom/'+selectedRate;

				let ajaxUrl;

				e.preventDefault();

				if (HE.dev) {
					ajaxUrl = HE.base_uri + dataUri;
				} else {
					ajaxUrl = dataUri;
				}

				function proceedWithSelection() {
					$.ajax({
						url       : ajaxUrl,
						method    : 'GET',
						beforeSend: function showBox() {
							$('#spinner-box').removeClass('d-none');
						}
					}).then(function processed(response) {
					console.log(response);
					if (response.redirect) {
						$('#spinner-box').addClass('d-none');
						$('.modal').modal('hide');
						window.location.replace(HE.base_uri + response.redirect);
					} else {
						$('.modal-dialog').addClass('mw-100 w-75');
						$('.modal').find('.modal-title').text('Please Login');
						$('.modal').find('.modal-body').html(response);
						$('.modal').modal('show');

						// eslint-disable-next-line no-undef
						grecaptcha.render('recaptcha', {
							sitekey : '6Le6uRYqAAAAAEPO0h76XxWzTpEv9PBSskfFCxz_',
							callback: function _callback(token) {
								if (token) {
									$('.captcha-submit').prop("disabled", false);
								}
							}
						});

						HE.Form.initAjaxForm('CustomerLogin');
						HE.Form.initAjaxForm('CustomerCreate');
						HE.Form.initAjaxForm('CustomerResetPassword');

						$('.modal').on('shown.bs.modal', function modalSwitch(e) {
							var signing = $(this).find('#signin-container');
							var create  = $(this).find('#create-container');
							var forgot  = $(this).find('#forgot-container');
							e.preventDefault();

							$('.captcha-submit').prop("disabled", true);

							// switch modal account forms
							$('a.create-switch').on('click', function switchForms(event) {
								create.removeClass('d-none');
								signing.addClass('d-none');
								forgot.addClass('d-none');
								$('.modal').find('.modal-title').text('Register');
								event.preventDefault();
							});

							$('a.signin-switch').on('click', function switchForms(event) {
								signing.removeClass('d-none');
								create.addClass('d-none');
								forgot.addClass('d-none');
								$('.modal').find('.modal-title').text('Please Login');
								event.preventDefault();
							});

							$('a.forgot-switch').on('click', function switchForms(event) {
								forgot.removeClass('d-none');
								create.addClass('d-none');
								signing.addClass('d-none');
								$('.modal').find('.modal-title').text('Account Recovery');
								event.preventDefault();
							});


							$('.show-pass').on('click', function showPass() {
								var sibling = $(this).siblings('span').find('input');
								var type    = sibling.attr('type');

								if (type === 'password') {
									sibling.attr('type', 'text');
									$(this).find('i').removeClass('fa-eye');
									$(this).find('i').addClass('fa-eye-slash');

								} else {
									sibling.attr('type', 'password');
									$(this).find('i').removeClass('fa-eye-slash');
									$(this).find('i').addClass('fa-eye');
								}
							});

							if ($('.monitor-password-changes').length > 0) {
								$('.monitor-password-changes').on('keyup change', function click(e)
								{
									var checks = HE.PasswordRequirements.testStrength($(this).val());
									HE.PasswordRequirements.applyUi(checks);
								});
							}
						});
					}
				})

				.always(function closeBox() {
					$('#spinner-box').addClass('d-none');
				});
				}

				if (childrenStayFree) {
					HE.CustomConfirm({
						title           : 'Please Confirm',
						body            : 'Please note that children will not be provided with an extra bed, and meals are not included. Any requested meals must be paid for directly to the hotel. Ensure your customers are informed of these conditions.',
						confirm_btn_text: 'Continue',
						cancel_btn_text : 'Cancel',
						confirm         : proceedWithSelection
					});
				} else {
					proceedWithSelection();
				}

			});

			// trigger any inputs that may be non-default for various reasons
			// (like on browser back, it'll re-select the rate, so ui needs to update)
			// $('input.rate-select').trigger('change');


			$('.thingy').on('click', function _toggleThingy(e) {
				var rate_key = $(this).data('rate-key');

				e.preventDefault();

				$('#ratedetails-body').html('<div class="text-center"><i class="fa fa-spinner fa-spin fa-3x"></i> Loading rate details...</div>');

				HE.Ajax.get('/Hotels/specialtyRateDetails/' + rate_key)
					.then(function _showReviews(data) {
						$('#ratedetails-body').html(data);
					});
			});

			$('.specialty-badge').on('click', function _showSpecialtyRateDetails(e) {
				var sabre_hotel_id = $(this).data('sabre-hotel-id'),
					rate_code      = $(this).data('rate-code');

				e.preventDefault();

				$('#ratedetails').offcanvas('show');
				$('#ratedetails-body').html('<div class="text-center"><i class="fa fa-spinner fa-spin fa-3x"></i> Loading rate details...</div>');

				HE.Ajax.get('/Hotels/loadSpecialtyRateDetails/' + encodeURIComponent(sabre_hotel_id) + '/' + encodeURIComponent(rate_code ))
					.then(function content(content) {
						$('#ratedetails-body').html(content);
					});
			});

			$('#specialty-search').on('keyup', function _searchSpecialtyRates() {
				var str_length      = $(this).val().length,
					keywordsToIgnore = ['additional', 'room'], // Array of keywords to ignore
					str_value        = $(this).val(),
					contents,
					room_code,
					regex;

				var shouldSearch = str_length >= 3 && !keywordsToIgnore.includes(str_value);

				if (shouldSearch) {
					// Existing specialty description search
					$('.specialty-description').each(function _searchSpecialtyRatesEach() {
						room_code = $(this).data('room-code');
						contents  = $(this).data('contents');
						regex     = new RegExp('('+str_value+')', 'gi');

						contents = contents.replace(regex, '<span class="bg-warning">$1</span>');
						$(this).html(contents);

						if (contents.toLowerCase().indexOf(str_value.toLowerCase()) === -1) {
							$('li[data-room-code="' + room_code + '"]').addClass('d-none');
						}

						$('.btn-clear').css('visibility', 'visible');
					});

					// New rate name search
					$('.rate-name').each(function _searchRateNames() {
						var $this = $(this);
						var rateName = $this.data('name');
						regex = new RegExp('(' + str_value + ')', 'gi');

						if (rateName && rateName.toLowerCase().indexOf(str_value.toLowerCase()) !== -1) {
							// Highlight matching text in rate name
							$this.html(rateName.replace(regex, '<span class="bg-warning">$1</span>'));
							$this.closest('li').removeClass('d-none');
						} else {
							// Remove highlighting if no match
							$this.html(rateName);
							// Only hide if specialty description is also not matching
							if ($this.closest('li').find('.specialty-description').text().toLowerCase().indexOf(str_value.toLowerCase()) === -1) {
								$this.closest('li').addClass('d-none');
							}
						}
					});

					// New room code search
					$('li.table-row').each(function _searchRoomCodes() {
						var $this = $(this);
						var roomCode = $this.data('room-code');
						regex = new RegExp('(' + str_value + ')', 'gi');

						if (roomCode && roomCode.toLowerCase().indexOf(str_value.toLowerCase()) !== -1) {
							// Highlight matching text in room code within the <a> tag with class "thingy"
							$this.find('a.thingy').html(roomCode.replace(regex, '<span class="bg-warning">$1</span>'));
							$this.removeClass('d-none');
						} else {
							// Remove highlighting if no match
							$this.find('a.thingy').html(roomCode);
							// Only hide if specialty description and rate name are also not matching
							if ($this.find('.specialty-description').text().toLowerCase().indexOf(str_value.toLowerCase()) === -1
								&& $this.find('.rate-name').text().toLowerCase().indexOf(str_value.toLowerCase()) === -1) {
								$this.addClass('d-none');
							}
						}
					});

					$('.btn-clear').css('visibility', 'visible');
				} else {
					$('li.table-row').removeClass('d-none');
					$('.btn-clear').css('visibility', 'hidden');
					$('.specialty-description span, .rate-name span').removeClass('bg-warning');
					// Restore original rate names
					$('.rate-name').each(function _restoreRateNames() {
						$(this).html($(this).data('name'));
					});
				}

				updateResultCount();
			});

			$('.btn-clear').on('click', function _clearSpecialtySearch() {
				$('#specialty-search').val('');
				$('li.table-row').removeClass('d-none');
				$('.specialty-description span, .rate-name span').removeClass('bg-warning');
				$('.thingy span').removeClass('bg-warning');
				// Restore original rate names
				$('.rate-name').each(function _restoreRateNames() {
					$(this).html($(this).data('name'));
				});
				$(this).css('visibility', 'hidden');

				updateResultCount();
			});

			$('.calendar-selector').on('click', function _showCalendar(e) {
				$('#datechange').offcanvas('show');
			});

			$('.more-details-icon').on('click', function _showMoreDetails(e) {
				var moreDetails = $(this).data('more-details');
				e.preventDefault();
				
				$('#moredetails-body').html(moreDetails);
				$('#moredetails').offcanvas('show');
			});

			if ($('#expedia_id').val() !== '') {
				HE.Ajax.get('/Hotels/reviews/' + $('#expedia_id').val())
					.then(function _showReviews(data) {
						$('.review-tab').removeClass('d-none');
						$('#reviews').removeClass('d-none');
						$('#reviews').html(data);
					});
			}

			if ($('#comparison_rate_code').val() !== '') {
				comparisonRateCode = $('#comparison_rate_code').val();

				$('#specialty-search').val(comparisonRateCode).trigger('keyup');
			}

			interval = setInterval(
				function _updateCurrentTimer() {
					// console.log(current_timer);

					if (current_timer >= max_time) {
						clearInterval(interval);

						HE.CustomConfirm({
							title  : 'Decision Time',
							content: 'You have been on this page longer than ' + max_time/60 + ' minutes. It is recommended to reload this hotel\'s details. Would you like to reload it now?',
							confirm: function confirm() {
								document.location = HE.base_uri + '/Hotels/processor/selectHotel/' + $('#giata_id').val();
							}
						});
					}

					current_timer++;
				},
				1000
			);

			updateResultCount();
		});

		HE.onload('/Hotels/displayReservation/', function onload()
		{
			$('.reservation-link').on('click', function setStorage() {
				localStorage.setItem('accountTab', 'reservations');
			});
		});

		function updateResultCount() {
			var visibleCount = $('li.table-row:not(.d-none)').length;
			var searchTerm;

			$('.result-count').text('(' + visibleCount + ')');

			// Remove existing alert if it exists
			$('#no-results-alert').remove();

			if (visibleCount === 0) {
				searchTerm = $('#specialty-search').val();
				// Add bootstrap alert for no results, including the search term in bold
				$('<div id="no-results-alert" class="alert alert-info mt-3" role="alert">'
					+ 'No results found for your search: <strong>' + searchTerm + '</strong>'
					+ '</div>').insertAfter('ul.table');
			}
		}

		// Initial count update
		updateResultCount();
	});
}(jQuery, window.HE || {}));